<template>
    <div class="flex flex-1 gap-x-8 px-8 mb-4">
        <jet-nav-link
            :href="route('customers.edit', customer.id)"
            :active="route().current('customers.edit')"
            :class="{ 'active': route().current('customers.edit') }"
            class="text-base subnav"
        >Profile</jet-nav-link>

        <jet-nav-link
            :href="route('customers.history', customer.id)"
            :active="route().current('customers.history')"
            :class="{ 'active': route().current('customers.history') }"
            class="text-base subnav"
        >Order History</jet-nav-link>

        <jet-nav-link
            :href="route('customers.users.index', customer.id)"
            :active="route().current('customers.users.index')"
            :class="{ 'active': route().current('customers.users.index') }"
            class="text-base subnav"
        >Users</jet-nav-link>

        <jet-nav-link v-if="isAdmin"
            :href="route('customers.card_vault', customer.id)"
            :active="route().current('customers.card_vault')"
            :class="{ 'active': route().current('customers.card_vault') }"
            class="text-base subnav"
        >Credit Card</jet-nav-link>
    </div>
</template>

<script>
import { usePage } from '@inertiajs/inertia-vue3'
import JetNavLink from '@/Jetstream/NavLink';
import UseUserAuth from '@/Composables/UseUserAuth';

export default {
    setup () {
        const { isAdmin } = UseUserAuth(usePage().props.value.user);

        return {
            isAdmin
        }
    },

    components: {
        JetNavLink,
    },

    props: ['customer'],
}
</script>

<style scoped>
.subnav {
    @apply border-white border-b-2 hover:border-red-dark font-semibold;
}
.subnav.active {
    @apply border-b-2 border-red-dark font-bold;
}
</style>